import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "fixed right-0 top-0 bottom-0 w-full sm:w-[520px] lg:w-[620px] bg-white shadow-2xl z-50 flex flex-col" }
const _hoisted_2 = { class: "flex items-start gap-3 min-w-0" }
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = { class: "text-lg font-bold text-dashboard-text" }
const _hoisted_5 = { class: "text-xs text-dashboard-muted mt-0.5 font-mono" }
const _hoisted_6 = { class: "text-xs text-dashboard-muted mt-1" }
const _hoisted_7 = { class: "flex-1 overflow-y-auto p-5 space-y-5" }
const _hoisted_8 = { class: "pt-2" }
const _hoisted_9 = {
  key: 1,
  class: "text-sm text-dashboard-muted italic"
}
const _hoisted_10 = { class: "text-dashboard-text" }
const _hoisted_11 = { class: "pt-2" }
const _hoisted_12 = { class: "font-mono" }
const _hoisted_13 = { class: "font-mono text-xs" }
const _hoisted_14 = { class: "flex items-center gap-2 min-w-0" }
const _hoisted_15 = { class: "font-mono text-xs truncate" }
const _hoisted_16 = { class: "text-xs text-dashboard-muted break-all" }
const _hoisted_17 = { class: "text-xs bg-dashboard-bg p-3 rounded-lg overflow-x-auto text-dashboard-text" }
const _hoisted_18 = { class: "border-t border-dashboard-border p-3 flex items-center justify-between gap-2 bg-dashboard-bg" }
const _hoisted_19 = { class: "text-xs text-dashboard-muted" }

import { computed } from 'vue'
import {
  X, User, Activity, MousePointer2, ListTree, Server, Copy, Code, ArrowLeftRight,
} from 'lucide-vue-next'

import Section from './DetailSection.vue'
import KV from './KV.vue'
import DiffView from './DiffView.vue'
import {
  SEVERITY_META, SOURCE_META, getActionLabel, getDomainMeta, getTargetLabel,
  formatDateTime, formatRelative,
} from '@/utils/auditMeta'
import type { AuditLogEntry } from '@/utils/auditMeta'


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditLogDetailPanel',
  props: {
    log: {}
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props


const domainMeta = computed(() => getDomainMeta(props.log.action))

const hasTarget = computed(() => Boolean(props.log.courrier_id || props.log.target_id))
const hasDiff = computed(() => {
  const b = props.log.before || {}
  const a = props.log.after || {}
  return Object.keys(b).length > 0 || Object.keys(a).length > 0
})
const hasDetails = computed(() => {
  const d = props.log.details
  return d && Object.keys(d).length > 0
})

function jsonPretty(value: any): string {
  try { return JSON.stringify(value, null, 2) } catch { return String(value) }
}

function truncateMiddle(s: string, total: number): string {
  if (s.length <= total) return s
  const half = Math.floor((total - 1) / 2)
  return `${s.slice(0, half)}…${s.slice(-half)}`
}

async function copy(text: string) {
  try {
    await navigator.clipboard.writeText(text)
  } catch {
    // no-op (some browsers block in non-secure contexts)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "fixed inset-0 bg-black/30 backdrop-blur-[1px] z-40",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }),
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['border-b border-dashboard-border p-5 flex items-start justify-between gap-3 border-l-4', _unref(SEVERITY_META)[_ctx.log.severity].ring])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(['p-2 rounded-lg flex-shrink-0', _unref(SEVERITY_META)[_ctx.log.severity].badge])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(SEVERITY_META)[_ctx.log.severity].icon), { class: "w-5 h-5" }))
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(getActionLabel)(_ctx.log.action)), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.log.action), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(formatDateTime)(_ctx.log.created_at)) + " · " + _toDisplayString(_unref(formatRelative)(_ctx.log.created_at)), 1)
          ])
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
          class: "p-2 hover:bg-dashboard-bg rounded-lg transition-colors flex-shrink-0",
          title: "Fermer"
        }, [
          _createVNode(_unref(X), { class: "w-5 h-5 text-dashboard-muted" })
        ])
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(Section, {
          title: "Qui",
          icon: _unref(User)
        }, {
          default: _withCtx(() => [
            (_ctx.log.user)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(KV, { label: "Nom" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.log.user.full_name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(KV, { label: "Username" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: `/audit/user/${_ctx.log.user.id}`,
                        class: "font-mono text-blue-600 hover:underline"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("@" + _toDisplayString(_ctx.log.user.username), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }),
                  _createVNode(KV, { label: "ID interne" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.log.user.id), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: `/audit/user/${_ctx.log.user.id}`,
                      class: "inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 border border-blue-200"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Activity), { class: "w-3 h-3" }),
                        _cache[4] || (_cache[4] = _createTextVNode(" Voir toute l'activité de cet utilisateur "))
                      ]),
                      _: 1,
                      __: [4]
                    }, 8, ["to"])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, "Action système ou utilisateur anonyme (pas de session)."))
          ]),
          _: 1
        }, 8, ["icon"]),
        _createVNode(Section, {
          title: "Quoi",
          icon: _unref(Activity)
        }, {
          default: _withCtx(() => [
            _createVNode(KV, { label: "Action" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getActionLabel)(_ctx.log.action)), 1)
              ]),
              _: 1
            }),
            _createVNode(KV, { label: "Domaine" }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(['inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium', domainMeta.value.badge])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(domainMeta.value.icon), { class: "w-3 h-3" })),
                  _createTextVNode(" " + _toDisplayString(domainMeta.value.label), 1)
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(KV, { label: "Sévérité" }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(['inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium', _unref(SEVERITY_META)[_ctx.log.severity].badge])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(SEVERITY_META)[_ctx.log.severity].icon), { class: "w-3 h-3" })),
                  _createTextVNode(" " + _toDisplayString(_unref(SEVERITY_META)[_ctx.log.severity].label), 1)
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(KV, { label: "Source" }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(['inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium', _unref(SOURCE_META)[_ctx.log.source].badge])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(SOURCE_META)[_ctx.log.source].icon), { class: "w-3 h-3" })),
                  _createTextVNode(" " + _toDisplayString(_unref(SOURCE_META)[_ctx.log.source].label), 1)
                ], 2)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["icon"]),
        (hasTarget.value)
          ? (_openBlock(), _createBlock(Section, {
              key: 0,
              title: "Sur quoi",
              icon: _unref(MousePointer2)
            }, {
              default: _withCtx(() => [
                (_ctx.log.courrier_id)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(KV, { label: "Type" }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("Courrier")
                        ])),
                        _: 1,
                        __: [5]
                      }),
                      _createVNode(KV, { label: "ID" }, {
                        default: _withCtx(() => [
                          _createTextVNode("#" + _toDisplayString(_ctx.log.courrier_id), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_router_link, {
                          to: `/audit/courrier/${_ctx.log.courrier_id}`,
                          class: "inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-lg bg-indigo-50 text-indigo-700 hover:bg-indigo-100 border border-indigo-200"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ListTree), { class: "w-3 h-3" }),
                            _cache[6] || (_cache[6] = _createTextVNode(" Voir la timeline de ce courrier "))
                          ]),
                          _: 1,
                          __: [6]
                        }, 8, ["to"])
                      ])
                    ], 64))
                  : (_ctx.log.target_id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(KV, { label: "Type" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(getTargetLabel)(_ctx.log.target_type)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(KV, { label: "ID" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.log.target_id), 1)
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["icon"]))
          : _createCommentVNode("", true),
        _createVNode(Section, {
          title: "Contexte technique",
          icon: _unref(Server)
        }, {
          default: _withCtx(() => [
            _createVNode(KV, { label: "Date / Heure" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(formatDateTime)(_ctx.log.created_at)), 1)
              ]),
              _: 1
            }),
            (_ctx.log.ip_address)
              ? (_openBlock(), _createBlock(KV, {
                  key: 0,
                  label: "Adresse IP"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.log.ip_address), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.log.session_key)
              ? (_openBlock(), _createBlock(KV, {
                  key: 1,
                  label: "Session"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(truncateMiddle(_ctx.log.session_key, 16)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.log.request_id)
              ? (_openBlock(), _createBlock(KV, {
                  key: 2,
                  label: "Request ID"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("code", _hoisted_15, _toDisplayString(_ctx.log.request_id), 1),
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (copy(_ctx.log.request_id!))),
                        class: "text-dashboard-muted hover:text-dashboard-text",
                        title: "Copier"
                      }, [
                        _createVNode(_unref(Copy), { class: "w-3.5 h-3.5" })
                      ]),
                      _createVNode(_component_router_link, {
                        to: `/audit/request/${_ctx.log.request_id}`,
                        class: "text-blue-600 hover:underline text-xs whitespace-nowrap",
                        title: "Voir toutes les entrées du même request_id"
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode(" Corrélation › ")
                        ])),
                        _: 1,
                        __: [7]
                      }, 8, ["to"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.log.user_agent)
              ? (_openBlock(), _createBlock(KV, {
                  key: 3,
                  label: "User-Agent"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.log.user_agent), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["icon"]),
        (hasDiff.value)
          ? (_openBlock(), _createBlock(Section, {
              key: 1,
              title: "Modifications",
              icon: _unref(ArrowLeftRight)
            }, {
              default: _withCtx(() => [
                _createVNode(DiffView, {
                  before: _ctx.log.before || {},
                  after: _ctx.log.after || {}
                }, null, 8, ["before", "after"])
              ]),
              _: 1
            }, 8, ["icon"]))
          : _createCommentVNode("", true),
        (hasDetails.value)
          ? (_openBlock(), _createBlock(Section, {
              key: 2,
              title: "Détails complémentaires",
              icon: _unref(Code)
            }, {
              default: _withCtx(() => [
                _createElementVNode("pre", _hoisted_17, _toDisplayString(jsonPretty(_ctx.log.details)), 1)
              ]),
              _: 1
            }, 8, ["icon"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, "Entrée #" + _toDisplayString(_ctx.log.id), 1),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (copy(JSON.stringify(_ctx.log, null, 2)))),
          class: "text-xs px-3 py-1.5 rounded-lg border border-dashboard-border hover:bg-white flex items-center gap-1.5"
        }, [
          _createVNode(_unref(Copy), { class: "w-3 h-3" }),
          _cache[8] || (_cache[8] = _createTextVNode(" Copier l'entrée (JSON) "))
        ])
      ])
    ])
  ]))
}
}

})